import { get, post, put, destroy } from './config';

const Driver = {
    createCompanyDriver: (data) =>
        post('v1/users/driver/add', data),
    createDriverByExpeditor: (data) =>
        post(`v1/users/expeditor/driver`, data),
    updateDriverByExpeditor: (driverId, data) =>
        put(`/v1/users/expeditor/driver/${driverId}`, data),
    deleteDriverByExpeditor: (driverId) =>
        destroy(`/v1/users/expeditor/driver/${driverId}`),
    getByCompany: (companyId, state, page) =>
        get(`v1/users/drivers?companyId=${companyId}&state=${state}&page=${page}`),
    assignDriver: (orderId, driverId) =>
        post(`v1/orders/book/by-${orderId}-and-${driverId}`),
    getDriversListByExpeditor: (expeditorId, params) =>
        get(`v1/users/drivers/by-expeditor-${expeditorId}`, { params }), // { params: { vehicleTypeId } }
    createVehicleByExpeditor: (data) =>
        post(`v1/vehicle`, data),
    getVehicleByExpeditor: (companyId, data) =>
        get(`v1/vehicle/list/${companyId}`, data),
    getVehicleTypes: () =>
        get("v1/directories/vehicle/types/"),
    getVehicleLoadingTypes: () =>
        get("v1/directories/vehicle/loading-types/"),
    createCnDriver: (data) =>
        post('v1/cnusers/driver', data),
    generateDriverUrl: (driverId) =>
        get(`v1/cnusers/driver/generate-url/${driverId}`),
    getDriverInfo: (driverId) =>
        get(`v1/users/driver/info/by-${driverId}`),
    getVehicleInfo: (vehicleId) =>
        get(`v1/vehicle/${vehicleId}`),
    updateVehicle: (vehicleId, data) =>
        put(`v1/vehicle/${vehicleId}`, data),
    assignDriverByExpeditor: (orderId, data) =>
        post(`v1/orders/expeditor/${orderId}/assign-driver`, data),
    updateAssignDriverByExpeditor: (orderId, id, data) =>
        put(`v1/orders/expeditor/${orderId}/assign-driver/${id}`, data),
}

export default Driver;